var _defs, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoenixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 180",
    style: {
      background: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phoenixGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#1ea7ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#28423e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,50 C140,45 120,55 105,70 C95,80 85,90 65,80 C90,75 100,65 110,55 C120,45 140,35 160,50 Z",
    fill: "#1ea7ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,55 C100,45 80,40 70,50 C50,65 30,70 10,60 C25,55 35,45 55,40 C70,35 90,40 100,50 C90,35 70,35 50,45 C30,55 10,55 0,45 C20,40 35,30 60,30 C85,30 100,45 110,55 Z",
    fill: "url(#phoenixGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,55 C115,50 120,50 125,55 L130,52 L128,58 L130,60 L125,58 C120,60 115,58 110,55 Z",
    fill: "#28423e"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 120,
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 900,
    fontSize: 28,
    textAnchor: "middle",
    fill: "#28423e"
  }, "PHOENIX")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 145,
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    textAnchor: "middle",
    fill: "#1ea7ac"
  }, "PORTAL")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoenixLogo);
export default __webpack_public_path__ + "static/media/phoenix-logo.85d87f864cfe900b4e40dc09189cd81d.svg";
export { ForwardRef as ReactComponent };